/** @jsxImportSource @emotion/react */
// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./ChipStyles";
// @otg-one/ui_components/components
import { Typography } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
import { ProductionSystem, StagedSystem } from "../../icons";

export const Chip = (props) => {
    const classes = useStyles(props);
    const {
        id,
        icon = null,
        color = Color.neutral[0],
        productionStyle,
        children = "",
        fontFamily = FONT_FAMILY.ROBOTO_MEDIUM,
        onClick = () => {},
        style,
        className = false,
    } = props;

    let iconUsed = null;

    if (!icon) {
        if (productionStyle === "production" || children === "PRODUCTION") {
            iconUsed = (
                <ProductionSystem style={{ color: Color.primary[300] }} />
            );
        } else if (productionStyle === "test" || children === "TEST") {
            iconUsed = <StagedSystem style={{ color: Color.neutral[0] }} />;
        }
    } else {
        iconUsed = React.createElement(props.icon, { style: { color } });
    }

    return (
        <div
            id={id}
            css={className === false ? classes.chipContainer : className}
            style={style}
            onClick={onClick}
        >
            {iconUsed}
            <Typography
                id={`${id}-chip-text`}
                fontFamily={fontFamily}
                size={12}
                color={color}
            >
                {children.toUpperCase()}
            </Typography>
        </div>
    );
};

export default React.memo(Chip);
